import React from "react";
import PropTypes from "prop-types";
import {useWillPipe} from "@morningtrain/react-helpers";
import {useRouter} from "../hooks";

function AddRouteToPayloadOnPipe() {

    const router = useRouter();

    useWillPipe((payload) => {
        return new Promise((resolve, reject) => {

            payload.route = {
                name: router.currentRoute,
                parameters: router.currentParameters,
            }

            resolve(payload);
        });
    });

    return null;
}

export default AddRouteToPayloadOnPipe;
